/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './putRecord.defs'
export { main as default } from './putRecord.defs'
